import { MapActionsSnackbarModule, MapActionsSnackbar } from '@/store/snackbar/map-actions.snackbar';
import { PerguntaInterface } from '@/shared/models/pergunta/pergunta.interface';
import { namespace } from 'vuex-class';

import { AxiosResponse } from 'axios';
import { PerguntaFilter } from '@/shared/models/pergunta/pergunta.filter';
import store from '@/store';
import { instanciaAxios } from './base.service';

const snackbar = namespace('snackbar');
const perguntas = 'perguntas';

export default class PerguntaService {
  // @ts-ignore
  @snackbar.Action(MapActionsSnackbar.SET_SNACKBAR_SUCCESS) setSnackbarSuccess;

  // @ts-ignore
  @snackbar.Action(MapActionsSnackbar.SET_SNACKBAR_ERROR) setSnackbarError;

  async pesquisar(body: PerguntaFilter): Promise<PerguntaInterface[]> {
    return await instanciaAxios.get('perguntas/pesquisa', { params: body })
      .then((response: any) => response.data)
      .catch((error: any) => {
        this.setSnackbarError(error.response.data);
        console.error(error);
      });
  }

  salvaOuAtualiza(pergunta: PerguntaInterface): Promise<AxiosResponse> {
    if (pergunta.id) {
      return this.atualizar(pergunta);
    }
    return this.cadastrar(pergunta);
  }

  buscarPorId(id: string): Promise<PerguntaInterface> {
    return instanciaAxios.get(`${perguntas}/${id}`);
  }

  cadastrar(body: PerguntaInterface) {
    return instanciaAxios.post(`${perguntas}`, body);
  }

  atualizar(body: PerguntaInterface) {
    return instanciaAxios.put(`${perguntas}/${body.id}`, body);
  }

  async excluir(body: PerguntaInterface): Promise<any> {
    await instanciaAxios.delete(`${perguntas}/${body.id}`)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Pergunta excluído com sucesso!');
      })
      .catch((error) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }
}
